export default __webpack_public_path__ + "9e5ed996dd27c165442648e80e6335d2.png";